// extracted by mini-css-extract-plugin
module.exports = {"searchHorizontalRecosContainer":"kP","reco":"lP","products":"mP"};